export class PbxAcl {
    id: number;
    type: string;
    address: string;
    addressSubnet: string;
    addressFrom: string;
    addressTo: string;
    pbxId: number;
}
